"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodedError = void 0;
/**
 * Utility class for better exception handling by way of having a code property
 * which is designated to uniquely identify the type of exception that was
 * thrown, essentially acting as a discriminator property.
 */
class CodedError extends Error {
    constructor(message, code) {
        super(message);
        this.message = message;
        this.code = code;
    }
    sameCode(codedError) {
        return this.code === (codedError === null || codedError === void 0 ? void 0 : codedError.code);
    }
}
exports.CodedError = CodedError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29kZWQtZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWFpbi90eXBlc2NyaXB0L2NvZGVkLWVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7O0dBSUc7QUFDSCxNQUFhLFVBQVcsU0FBUSxLQUFLO0lBQ25DLFlBQTRCLE9BQWUsRUFBa0IsSUFBWTtRQUN2RSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFEVyxZQUFPLEdBQVAsT0FBTyxDQUFRO1FBQWtCLFNBQUksR0FBSixJQUFJLENBQVE7SUFFekUsQ0FBQztJQUVELFFBQVEsQ0FBQyxVQUFzQjtRQUM3QixPQUFPLElBQUksQ0FBQyxJQUFJLE1BQUssVUFBVSxhQUFWLFVBQVUsdUJBQVYsVUFBVSxDQUFFLElBQUksQ0FBQSxDQUFDO0lBQ3hDLENBQUM7Q0FDRjtBQVJELGdDQVFDIn0=